import messages from '../../utils/messages';

const triggerEvent = (messageType) => {
  if (window === window.parent) {
    return;
  }

  messages.send(window.parent, { action: messageType });
};

export default triggerEvent;
